import { useEffect } from 'react';
import { SMP_PATH } from '@/constants/paths';
import { useSMPNavigate } from './useSMPNavigate';

/**
 * Redirects to the SMP landing page when maintenance mode is active.
 * Call this at the top of any SMP sub-page that should be blocked
 * during scheduled maintenance.
 */
export const useMaintenanceGuard = (showMaintenance: boolean) => {
  const { smpNavigate } = useSMPNavigate();

  useEffect(() => {
    if (showMaintenance) {
      // Preserve the selected `?subscriptionId=` so multi-sub users land on the
      // maintenance flow for the sub they were managing, not the account selector.
      smpNavigate(SMP_PATH, { replace: true });
    }
  }, [showMaintenance, smpNavigate]);
};
